<div class="main__aviso">

    <div class="aviso__header">
        <fa-icon [icon]="faExclamation"></fa-icon>
        <h4>Aviso</h4>        
    </div>

    <p class="content-main">
        <ng-content></ng-content>
    </p>

    <p *ngIf="textoAviso">
        {{textoAviso}}
        <span *ngIf="valor">
            {{valor}}
        </span>
    </p>
</div>